import { render, staticRenderFns } from "./groupItem.vue?vue&type=template&id=2a1a7e81&scoped=true"
import script from "./groupItem.vue?vue&type=script&lang=js"
export * from "./groupItem.vue?vue&type=script&lang=js"
import style0 from "./groupItem.vue?vue&type=style&index=0&id=2a1a7e81&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a7e81",
  null
  
)

export default component.exports